import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export interface TokenStore {
  token: string;
  uniBaseUrl : string ;
  force_user_to_complete_profile?: boolean;
  setToken: (data: string) => void;
  setUniBaseUrl: (data: string) => void;
  setForceUserToCompleteProfile: (data: boolean) => void;
}

const useTokenStore = create<TokenStore>()(
  devtools(
    persist(
      (set) => ({
        token: "",
        uniBaseUrl: "",
        setToken: (data: string) => set(() => ({ token: data })),
        setUniBaseUrl: (data: string) => set(() => ({ uniBaseUrl: data })),
        force_user_to_complete_profile: false,
        setForceUserToCompleteProfile: (data: boolean) =>
          set(() => ({ force_user_to_complete_profile: data })),
      }),
      { name: "token-store" }
    )
  )
);

export default useTokenStore;
